export const ItemsData = [
    {
        index: 1,
        itemX: 227,
        itemY: 347,
        zoneId: 0,
        trueId: 0,
        image: "prod",
        otherId: 0
    },
    {
        index: 2,
        itemX: 87,
        itemY: 540,
        zoneId: 1,
        trueId: 1,
        image: "matieres",
        otherId: 0
    },
    {
        index: 3,
        itemX: 183,
        itemY: 540,
        zoneId: 1,
        trueId: 2,
        image: "marchandise",
        otherId: 0
    },
    {
        index: 4,
        itemX: 280,
        itemY: 540,
        zoneId: 1,
        trueId: 3,
        image: "energie",
        otherId: 0
    },
    {
        index: 5,
        itemX: 375,
        itemY: 540,
        zoneId: 1,
        trueId: 4,
        image: "sousTraitance",
        otherId: 0
    },
    {
        index: 6,
        itemX: 532,
        itemY: 507,
        zoneId: 2,
        trueId: 5,
        image: "salaire",
        otherId: 0
    },
    {
        index: 7,
        itemX: 700,
        itemY: 507,
        zoneId: 2,
        trueId: 6,
        image: "impots",
        otherId: 0
    },
    {
        index: 8,
        itemX: 904,
        itemY: 530,
        zoneId: 3,
        trueId: 7,
        image: "usure",
        otherId: 0
    },
    {
        index: 9,
        itemX: 1060,
        itemY: 530,
        zoneId: 3,
        trueId: 8,
        image: "obsolescence",
        otherId: 0
    },
    {
        index: 10,
        itemX: 1334,
        itemY: 518,
        zoneId: 4,
        trueId: 9,
        image: "resultat",
        otherId: 0
    },
    {
        index: 11,
        itemX: 1583,
        itemY: 545,
        // zoneId: 5,
        // trueId: 10,
        zoneId: 3,
        trueId: 7,
        image: "usure",
        otherId:7
    },
    {
        index: 12,
        itemX: 1694,
        itemY: 545,
        // zoneId: 5,
        // trueId: 11,
        zoneId: 3,
        trueId: 8,
        image: "obsolescence",
        otherId:7
    },
    {
        index: 13,
        itemX: 1818,
        itemY: 545,
        zoneId: 6,
        trueId: 12,
        image: "venteImmo",
        otherId: 0
    },
]